import bytes from 'bytes'

export const UPLOAD_CHUNK_SIZE = bytes.parse('50MB')

export const RECORD_FILE_NAME = `RECORD_${Date.now()}`

export const RECORD_MAX_DURATION = 60 // seconds
